module.exports = __webpack_public_path__ + "img/icon_zhichiduozuhu.d34ff640.png";